import { executeFunctionByName } from './utils';
export function initAjaxTables() {
  let sections = document.querySelectorAll('[data-ajax-table]');

  sections.forEach((section, index, parent) => {
	initRemoveButtons(section);
	initAddButtons(section);
  });
}

export function initAddButtons(section) {
  let options = JSON.parse(section.dataset.ajaxTable);
  let addBtns = section.querySelectorAll(options.add.selector)

  addBtns.forEach((addButton, index, parent) => {
	let newButton = addButton.cloneNode(true);
	addButton.parentNode.replaceChild(newButton, addButton);
	newButton.addEventListener('click', (e) => handleAddButton(section, e));
  });
}

function handleAddButton(section, e) {
  e.preventDefault();
  e.stopPropagation();
  let options = JSON.parse(section.dataset.ajaxTable);

  let url = options.add.url;

  let data = new FormData();
  let parameters = section.querySelectorAll(options.add.parameterSelector)
  parameters.forEach((parameter, index, parent) => {
	console.log(parameter);
	data.append(parameter.attributes.name.value, parameter.value);
  });

  fetch(url, {
	method: 'POST',
	headers: { 'RequestVerificationToken': antiforgeryRequestToken },
	body: new URLSearchParams(data)
  })
	.then(response => {
	  if (!response.ok)
		throw new Error(response);
	  return response.text()
	})
	.then(data => {
	  var template = document.createElement('template');
	  template.innerHTML = data.trim();
	  let tbody = section.querySelector(`${options.table.selector} > tbody`);

	  switch (options.table.position) {
		case 'top':
		  tbody.prepend(template.content);
		  break;
		case 'bottom':
		default:
		  tbody.appendChild(template.content);
		  break;
	  }
	  resetParameters(section);
	  initRemoveButtons(section);
	  checkEmptyTable(section);
	  checkCallback(options.add.callback);
	})
	.catch(error => { console.error(error); });
}

export function checkEmptyTable(section) {
  let options = JSON.parse(section.dataset.ajaxTable);
  let tfoot = section.querySelector(`${options.table.selector} > tfoot`);
  if (section.querySelectorAll(`${options.table.selector} > tbody tr`).length == 0) {
	tfoot.classList.remove('hidden');
  } else {
	tfoot.classList.add('hidden');
  }
}

export function initRemoveButtons(section) {
  let options = JSON.parse(section.dataset.ajaxTable);
  let removeBtns = section.querySelectorAll(options.remove.selector)
  removeBtns.forEach((removeBtn, index, parent) => {
	let newButton = removeBtn.cloneNode(true);
	removeBtn.parentNode.replaceChild(newButton, removeBtn);
	newButton.addEventListener('click', (e) => handleRemoveButton(section, e));
  });
}

function handleRemoveButton(section, e) {
  e.preventDefault();
  e.stopPropagation();

  let options = JSON.parse(section.dataset.ajaxTable);

  let tr = e.currentTarget.closest('tr');
  tr.remove();

  checkEmptyTable(section);
  checkCallback(options.remove.callback);
}

function resetParameters(section) {
  let options = JSON.parse(section.dataset.ajaxTable);
  let parameters = section.querySelectorAll(options.add.parameterSelector)
  parameters.forEach((parameter, index, parent) => {
	parameter.value = null;
	if (parameter.slim) {
	  parameter.slim.setSelected('');
	}
  });
}

function checkCallback(callbackFunction) {
  if (callbackFunction) {
	executeFunctionByName(callbackFunction, window);
  }
}

initAjaxTables();